import axios from "axios";
import {PaginateModel} from "../../../models/PaginateModel";
import {ADMIN_PRODUCTS_ENDPOINT, IMPORT_REQUEST_ENDPOINT} from "../../../constants/endpoints";
import { ISearchProductModel } from "../../../models/OrderModel";
import { ResponseModel } from "../../../models/ResponseModel";
import { ImportRequestDetailModel, ImportRequestModel, SearchModel } from "../../../models/ImportRequestModel";
import { ISearch } from "../../../models/WareHouseModel";


export interface ImportRequestHistModel {
  paginate_data: PaginateModel<ImportRequestDetailModel>,
  sum_total: number
}

export interface ImportRequestListModel {
  paginate_data: PaginateModel<ImportRequestModel>,
  sum_total: number
}

export function getList(params?: SearchModel) {
  return axios.get<ImportRequestListModel>(`${IMPORT_REQUEST_ENDPOINT}`, {params})
}

export function getProductList(params: ISearchProductModel) {
  return axios.get(`${ADMIN_PRODUCTS_ENDPOINT}`, {params})
}

export function getDetail(id?: string) {
  return axios.get<ResponseModel>(`${IMPORT_REQUEST_ENDPOINT}/${id}`)
}

export function updateRequest(id: number, importRequest: ImportRequestModel, removeIds: number[]) {
  return axios.post<ResponseModel>(`${IMPORT_REQUEST_ENDPOINT}/${id}`, {
    import_request: importRequest,
    remove_ids: removeIds
  })
}

export function getListProducts(params?: ISearch) {
  return axios.get<ImportRequestHistModel>(`${IMPORT_REQUEST_ENDPOINT}/get-products`, {params})
}

export function exportPdf(params: { id: number }) {
  return axios.post(`${IMPORT_REQUEST_ENDPOINT}/export-pdf-landscape`, params)
}

export function exportDetails(id: number) {
  return axios.get(`${IMPORT_REQUEST_ENDPOINT}/export-details/${id}`, {responseType: 'blob'})
}